import { LogService } from "./../../_services/log.service";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { Router } from "@angular/router";

import { AuthenticationService } from "../../_services/authentication.service";
import { AppService } from "app/_services/app.service";
import { Login } from "../../_models/login";
import { LogFrontFuncionalidade } from "app/_enums/log-front-funcionalidade";
import { Operacao } from "app/_enums/operacao";

declare var ocultarControleMenu: any;

@Component({
  selector: "app-login-modal",
  templateUrl: "./login-modal.component.html",
  styleUrls: ["./login-modal.component.scss"],
  exportAs: "child",
})
export class LoginModalComponent implements OnInit {
  tokenExpirado: boolean = false;
  labelLinkResetSenha: string = "Esqueci minha senha";
  public login: Login = new Login();
  error = '';
  shouldRedirect = false;
  redirectTime = 5000; // milliseconds
  loading = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private _appService: AppService,
    private _logService: LogService
  ) {}

  ngOnInit() {}

  @ViewChild("lgModal", { static: true }) lgModal;

  public showModal(modal): void {
    if (modal) {
      //this.tokenExpirado = this.authenticationService.tokenExpirado;
      this.tokenExpirado = this._appService.tokenExpirado;
      this.lgModal.show();
    } else this.lgModal.hide();
  }

  private redirectToExternal() {
    this.shouldRedirect = true
    setTimeout(() => {
      window.location.href = 'https://www.portalcabotagem.com.br';
    }, this.redirectTime);
  }

  efetuarLogin() {
    this.shouldRedirect = false;
    this.loading = true;
    console.log(this.login);
    this.authenticationService.login(this.login).subscribe(
      (result) => {
        this.error = "";
        if (result.IsValid) {
          this.login = new Login();
          this.authenticationService.hideModal();

          let usuario = this._appService.UsuarioLogado;
          let descricaoPerfis = [
            "Cliente Master",
            "Cliente Tracking",
            "Cliente Booking e Rastreamento",
            "Cliente Financeiro Operacional",
          ];
          if (
            descricaoPerfis.some(
              (perfil) => perfil === usuario.perfil.descricao
            )
          )
            this.router.navigate(["/rastreamento"]);
          else this.router.navigate(["/home"]);

          this._appService.tokenExpirado = false;
          ocultarControleMenu();
        } else {
          const errorResponse = result.Erros[0]
          const REDIRECT_ERROR_MESSAGE = 'Usuário inativo'
          const novoSiteVendor = this._appService.configInfo.novoSiteVendor;

          if (errorResponse.Message === REDIRECT_ERROR_MESSAGE) {
            this.error = `Estamos te redirecionando para o site oficial em ${this.redirectTime / 1000} segundos`
            this.redirectToExternal()
          } else if (errorResponse.ErrorCode.includes("VND10")) {
            this.error = `Usuário não encontrado. Para acesso de Transportador, favor acessar o site <a href='${novoSiteVendor}' target='_blank'>${novoSiteVendor}</a>`;
            this.labelLinkResetSenha = 'Esqueci minha senha';
          } else {
            this.error = errorResponse.ErrorCode + ' ' + errorResponse.Message;
            this.labelLinkResetSenha = (errorResponse.Message == 'Senha expirada') ? 'Clique aqui para Trocar / Reativar sua senha' : 'Esqueci minha senha';
          }

          this._appService.tokenExpirado = true;
          this._logService.logFront(this.login.username, LogFrontFuncionalidade.Login, this.error, Operacao.Login, "LOGIN");
        }
        this.loading = false;
      },
      (err) => {
        this.error = err;
        this.loading = false;
      }
    );
  }

  ResetSenha() {
    this.authenticationService.hideModal();
    this.router.navigate(["/resetsenha"]);
  }
}
